export default {
  alert: {
    boxShadow: '2px 5px 5px 0 rgba(0, 0, 0, .2)'
  }
}
